import { mapGetters } from 'vuex'

export default {
  name: 'CheckEmailPage',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'emailAddress'
    ])
  },
  methods: {
    emailVerified (evt) {
      evt.preventDefault()
      this.$router.push('/crops')
      window.location.reload(true)
    },
    signUpForm (evt) {
      evt.preventDefault()
      this.$router.push('/sign-up')
    }
  }
}
